import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b479e5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-x2" }, "Sổ cân đối hàng tồn kho", -1))
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bolder text-uppercase" }, " sổ cân đối hàng tồn kho ", -1))
const _hoisted_7 = {
  class: "text-center mb-1 fst-italic",
  style: {"font-size":"0.8rem"}
}
const _hoisted_8 = {
  class: "text-center",
  style: {"font-size":"0.9rem"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-end mb-0 fst-italic",
  style: {"font-size":"0.8rem"}
}, " ĐVT: đồng ", -1))
const _hoisted_11 = { class: "row mt-2" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = {
  class: "d-flex justify-content-between mx-5 align-items-end",
  style: {"font-size":"0.8rem"}
}
const _hoisted_14 = { class: "flex flex-column justify-content-end align-items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-center my-2 fst-italic",
  style: {"font-size":"0.8rem"}
}, " Ngày ..... tháng ..... năm ..... ", -1))

import {
  computed,
  PropType,
  ref,
} from 'vue';
import {
  IKhoResponseBase,
  IVatTuHangTonKhoItemV2ResponseBase,
} from '@/core/interfaces/ApiResponses';
import { printHtmlElement } from '@/core/helpers/html-to-paper';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import HangTonKhoTable from '../table-components/HangTonKhoTable.vue';
import SignatureCol from '@/layout/_shared/SignatureCol.vue';
import PdfDocumentHeader from "@/components/shared/pdf-viewer/PdfDocumentHeader.vue";
import { useAuthPdfDonVi } from "@/core/hooks/use-auth-pdf-don-vi";


export default /*#__PURE__*/_defineComponent({
  __name: 'HangTonKhoPrintModal',
  props: {
  tenDonVi: { type: String, default: "" },
  tenDonViCha: { type: String, default: "" },
  from: {
    type: Date,
    default: new Date(),
  },
  items: {
    type: Array as PropType<IVatTuHangTonKhoItemV2ResponseBase[]>,
    required: true,
  },
  kho: {
    type: Object as PropType<IKhoResponseBase | null>,
    default: null,
  },
  to: {
    type: Date,
    default: new Date(),
  },
},
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const authDonVi = useAuthPdfDonVi();
const resolvedTenDonVi = computed(
  () => props.tenDonVi || authDonVi.tenDonVi.value
);
const resolvedTenDonViCha = computed(
  () => props.tenDonViCha || authDonVi.tenDonViCha.value
);


const { ButtonsType } = useButtonCustom();

const isOpen = ref(false);

const modalId = ref('so-can-doi-hang-ton-kho-print-modal');

__expose({
  isOpen,
});

const emit = __emit;

const dateTime = computed(() => {
  const { from, to } = props;

  return `Từ ${from.getMonth() + 1} năm ${from.getFullYear()} đến tháng ${
    to.getMonth() + 1
  } năm ${to.getFullYear()}`;
});

const onPrintingButtonClicked = () => {
  printHtmlElement(modalId.value);
};

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    width: "90%",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(DivRow, { class: "mb-2" }, {
          default: _withCtx(() => [
            _createVNode(DivCol, { cols: 10 }),
            _createVNode(DivCol, {
              cols: 2,
              class: "text-end justify-content-end"
            }, {
              default: _withCtx(() => [
                _createVNode(ButtonCustom, {
                  "button-type": _unref(ButtonsType).PRINT,
                  onClick: onPrintingButtonClicked
                }, {
                  "button-label": _withCtx(() => [
                    _createTextVNode("In phiếu")
                  ]),
                  _: 1
                }, 8, ["button-type"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          id: modalId.value,
          class: "printing-paper"
        }, [
          _createVNode(PdfDocumentHeader, {
            "ten-don-vi": resolvedTenDonVi.value,
            "ten-don-vi-cha": resolvedTenDonViCha.value
          }, null, 8, ["ten-don-vi", "ten-don-vi-cha"]),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, _toDisplayString(dateTime.value), 1),
              _createElementVNode("p", _hoisted_8, " Kho: " + _toDisplayString(__props.kho?.ten_kho), 1)
            ]),
            _hoisted_9
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(HangTonKhoTable, {
                "is-print-modal": true,
                items: __props.items,
                stripe: false
              }, null, 8, ["items"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, [
              _createVNode(SignatureCol, { "nguoi-ky": "Thủ kho" })
            ]),
            _createElementVNode("div", null, [
              _createVNode(SignatureCol, { "nguoi-ky": "Người giữ sổ" })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(SignatureCol, { "nguoi-ky": "TP Tài Chính" })
            ])
          ])
        ], 8, _hoisted_2)
      ])), [
        [_directive_dialog_auto_focus, isOpen.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})